import * as React from 'react';
import cn from 'classnames';

import { PropTypes, defaultProps } from '../IconProps';

const Component: React.FC<PropTypes> = ({
  className,
  size = 32,
  ...rest
}: PropTypes) => (
  <svg
    className={cn(className)}
    style={{ width: `${size}px`, height: `${size}px` }}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="none"
    {...rest}
  >
    <g clipPath="url(#clip0_9759_5279)" fillRule="evenodd" clipRule="evenodd">
      <path
        d="M9.48 21.015H7.688v-4.547a.917.917 0 00-.554-.846.883.883 0 00-.979.198.94.94 0 00-.26.648v4.547h-1.8v-4.547a.917.917 0 00-.554-.846.883.883 0 00-.98.198.94.94 0 00-.26.648v4.547H.5v-4.547c0-.833.308-1.522.923-2.066.25-.214.527-.38.828-.498a2.596 2.596 0 011.906.01c.314.125.59.34.827.648.11-.151.235-.28.376-.387a2.1 2.1 0 01.93-.405c.166-.029.331-.043.494-.043.374 0 .724.07 1.052.214a2.71 2.71 0 011.434 1.457c.14.335.21.691.21 1.07v4.547zm8.138-3.644c0 .535-.095 1.033-.284 1.495-.189.46-.446.86-.771 1.196a3.609 3.609 0 01-1.144.796c-.438.194-.907.291-1.408.291-.497 0-.964-.097-1.401-.29a3.648 3.648 0 01-1.148-.797 3.715 3.715 0 01-.774-1.197 3.905 3.905 0 01-.284-1.494c0-.544.095-1.048.284-1.511a3.601 3.601 0 011.922-1.993 3.452 3.452 0 011.4-.288c.502 0 .971.09 1.409.271.437.18.818.437 1.144.77.325.331.582.73.771 1.196a4.1 4.1 0 01.284 1.555zm-1.814 0c0-.294-.047-.56-.141-.8a1.9 1.9 0 00-.386-.614 1.665 1.665 0 00-.57-.395 1.778 1.778 0 00-.696-.137c-.246 0-.478.046-.696.137a1.632 1.632 0 00-.567.395c-.16.171-.287.376-.38.615a2.198 2.198 0 00-.138.799c0 .276.047.533.139.769.092.236.219.441.38.615.16.174.349.311.566.411a1.742 1.742 0 001.962-.384c.163-.17.291-.375.386-.615a2.16 2.16 0 00.141-.796zm4.623 3.644h-1.814v-4.82l1.814-2.328v3.45l2.683-3.45h2.07l-2.34 2.982 2.34 4.166h-2.07l-1.43-2.6-1.253 1.684v.916zM32.5 17.371c0 .535-.094 1.033-.283 1.495-.19.46-.447.86-.772 1.196a3.61 3.61 0 01-1.144.796c-.437.194-.907.291-1.408.291-.497 0-.964-.097-1.401-.29a3.648 3.648 0 01-1.147-.797 3.714 3.714 0 01-.775-1.197 3.903 3.903 0 01-.284-1.494c0-.544.095-1.048.284-1.511a3.601 3.601 0 011.922-1.993 3.452 3.452 0 011.401-.288c.501 0 .97.09 1.408.271.437.18.819.437 1.144.77.325.331.582.73.772 1.196a4.1 4.1 0 01.283 1.555zm-1.813 0c0-.294-.048-.56-.142-.8a1.902 1.902 0 00-.386-.614 1.667 1.667 0 00-.57-.395 1.778 1.778 0 00-.696-.137c-.246 0-.478.046-.695.137a1.633 1.633 0 00-.568.395c-.16.171-.286.376-.379.615a2.198 2.198 0 00-.138.799c0 .276.046.533.138.769.093.236.219.441.38.615.16.174.349.311.567.411a1.742 1.742 0 001.962-.384c.162-.17.29-.375.385-.615a2.16 2.16 0 00.142-.796z"
        fill="#684CDC"
      />
      <path d="M20.427 13.106l-1.814 2.321V11h1.814v2.106z" fill="#272044" />
    </g>
    <defs>
      <clipPath id="clip0_9759_5279">
        <path fill="#fff" transform="translate(.5)" d="M0 0H32V32H0z" />
      </clipPath>
    </defs>
  </svg>
);

Component.defaultProps = defaultProps;

export default Component;
